export default "__VITE_ASSET__0983169c__"